module.exports = __webpack_public_path__ + "img/icon-evening-2.13f50d41.png";